var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("tw-mention-list items " + (_vm.hasGroupTitle ? 'has-group-title' : ''))},_vm._l((_vm.showItems),function(item,index){return _c('button',{key:index,class:{
      'item': true,
      'is-selected': index === _vm.selectedIndex,
      'is-unmentionable': item.unmentionable,
      'is-group-title': item.isTitle
    },attrs:{"disabled":item.unmentionable},on:{"click":function($event){return _vm.selectItem(index)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }